import type { Locale } from "./locale.ts";

export type MessageCatalog = Readonly<Record<string, string>>;

/** One chunk per locale: only the active language is downloaded. */
export async function loadMessages(locale: Locale): Promise<MessageCatalog> {
  const module =
    locale === "pt-BR"
      ? await import("../../locales/pt-BR.json")
      : await import("../../locales/en.json");
  return module.default;
}
